import { Length, ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class InventoryModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @ShortString('data-model.inventory-model.validation.name.length')
    @Required('data-model.inventory-model.validation.name.non-empty')
    public name: string;

    @Property()
    @Required('data-model.inventory-model.validation.symbol.non-empty')
    @Length({ max: 3 }, 'data-model.inventory-model.validation.symbol.length')
    public symbol: string;
}
